// The FarmVille-1 vehicle: it pops in at the middle of the area being worked (fade in, a small
// random offset), bounces and wobbles while dust puffs behind it (Kombajn: chaff), shows
// "Orka: 30%" in a green bar above, and fades out when the area is done. It never drives.
import { WORK_LABEL } from './vehicles.mjs';
import { vehicleTexture } from './farmPlaceholders.js';
import { TILE_W } from './iso.mjs';
import { iconText } from '../ui/iconText.js';

const FONT = 'system-ui, -apple-system, sans-serif';
const DISPLAY_W = { 2: TILE_W * 1.15, 4: TILE_W * 1.9 };   // art is ~2× these
const DUST = { tractor: 0xb08850, seeder: 0xb08850, harvester: 0xe8d27a };

export class FarmVehicle {
  constructor(scene, world) {
    this.scene = scene;
    this.world = world;
    this.root = scene.add.container(0, 0).setVisible(false).setDepth(1e8);
    this.sprite = scene.add.image(0, 0, '__DEFAULT').setOrigin(0.5, 0.85);
    this.barBg = scene.add.rectangle(0, 0, 150, 22, 0x2e7d32, 0.9).setStrokeStyle(2, 0xffffff, 0.8);
    this.barFill = scene.add.rectangle(-73, 0, 0, 18, 0x7ed957, 1).setOrigin(0, 0.5);
    this.barText = iconText(scene, 0, 0, '', { fontFamily: FONT, fontSize: '14px', color: '#fff', fontStyle: 'bold' }).setOrigin(0.5);
    this.root.add([this.sprite, this.barBg, this.barFill, this.barText]);
    world.objects.add(this.root);
    this._tweens = [];
    this._dust = null;
  }

  popIn(tool, size, centre, action) {
    this._stop();
    const key = vehicleTexture(this.scene, tool, size);
    this.sprite.setTexture(key);
    const src = this.scene.textures.get(key).getSourceImage();
    const w = DISPLAY_W[size];
    this.sprite.setDisplaySize(w, w * src.height / src.width).setAngle(0).setY(0);
    const jx = (Math.random() - 0.5) * 8, jy = (Math.random() - 0.5) * 4;
    this.root.setPosition(centre.x + jx, centre.y + jy).setAlpha(0).setVisible(true);
    const barY = -this.sprite.displayHeight * 0.85 - 18;
    for (const o of [this.barBg, this.barText]) o.setY(barY);
    this.barFill.setY(barY).width = 0;
    this._label = WORK_LABEL[action];
    this.barText.setText(`${this._label}: 0%`);
    this._tweens.push(this.scene.tweens.add({ targets: this.root, alpha: 1, duration: 180 }));
    this._tweens.push(this.scene.tweens.add({ targets: this.sprite, y: -3, duration: 110, yoyo: true, repeat: -1, ease: 'Sine.InOut' }));
    this._tweens.push(this.scene.tweens.add({ targets: this.sprite, angle: { from: -1.5, to: 1.5 }, duration: 170, yoyo: true, repeat: -1, ease: 'Sine.InOut' }));
    this._dust = this.scene.time.addEvent({ delay: 90, loop: true, callback: () => this._puff(tool) });
  }

  setProgress(p) {
    this.barFill.width = 146 * p;
    this.barText.setText(`${this._label}: ${Math.round(p * 100)}%`);
  }

  popOut() {
    this._dust?.remove(); this._dust = null;
    // Tracked like the rest, so a pop-in for the next area (one frame later) cancels this fade
    // instead of being hidden by it when it completes.
    this._tweens.push(this.scene.tweens.add({ targets: this.root, alpha: 0, duration: 220, onComplete: () => { this._stop(); this.root.setVisible(false); } }));
  }

  _puff(tool) {
    const s = this.sprite;
    const x = this.root.x - s.displayWidth * 0.35 + (Math.random() - 0.5) * 10;
    const y = this.root.y - 4 + (Math.random() - 0.5) * 6;
    const c = this.scene.add.circle(x, y, 5 + Math.random() * 4, DUST[tool], 0.55).setDepth(this.root.depth - 1);
    this.world.objects.add(c);
    this.scene.tweens.add({ targets: c, x: x - 14, y: y - 10, scale: 2.2, alpha: 0, duration: 650, ease: 'Cubic.Out', onComplete: () => c.destroy() });
  }

  _stop() { for (const t of this._tweens) t.remove(); this._tweens = []; this._dust?.remove(); this._dust = null; }

  destroy() { this._stop(); this.root.destroy(true); }
}
